import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import { EventsUIProvider } from './EventsContextProvider';

const EventsPage = React.lazy(() => import('./EventsPage'));

function Events(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>رویداد ها</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <EventsUIProvider>
          <EventsPage {...props} />
        </EventsUIProvider>
      </Suspense>
    </Page>
  );
}

export default Events;
